import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { ScheduleType } from 'types/schedule'
import { BreadType } from 'types/bread'
import { StockType, StockUnionType } from 'types/stock'

const getInitialStock = (
  bread: BreadType,
  strDate: string,
  pickupableTime: string,
  schedule: ScheduleType,
  stock: number,
  stockRef: FirebaseDocRefType | undefined,
  storeName: string,
  storeRef: FirebaseDocRefType,
  type: StockUnionType
): StockType => {
  return {
    bread_ref: schedule.bread_ref,
    bread_name: bread.name,
    date: strDate,
    choices: schedule.choices,
    deadline: FirebaseTimestamp.now(),
    image_url: bread.image_urls[0] || '',
    is_deleted: false,
    last_notified_time: null,
    maximum_order: schedule.maximum_order,
    note: schedule.note,
    options: schedule.options,
    pickupable_time: pickupableTime,
    price: bread.price,
    stock: stock,
    stock_ref: stockRef,
    store_name: storeName,
    store_ref: storeRef,
    type: type,
  }
}

export default getInitialStock
